module.exports = __webpack_public_path__ + "img/profile-circle.c3e7873a.svg";